import React, { useState } from 'react';
import { X, Camera, Heart, XCircle } from 'lucide-react';

const TikTokConsentModal = ({ open, onChoice, onClose }) => {
  const [busy, setBusy] = useState(false);
  if (!open) return null;

  const pick = async (accepted) => {
    setBusy(true);
    try { await onChoice(accepted); } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-testid="tiktok-consent-modal">
      <div className="relative w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-300">
        <div className="relative h-32 bg-gradient-to-br from-[#F4A340] via-pink-400 to-[#E89534] flex items-center justify-center">
          <button onClick={onClose} className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/30 hover:bg-white/50 text-white flex items-center justify-center transition">
            <X className="w-4 h-4" />
          </button>
          <div className="w-16 h-16 rounded-2xl bg-white/95 flex items-center justify-center shadow-lg">
            <Camera className="w-8 h-8 text-[#E89534]" />
          </div>
        </div>

        <div className="px-6 py-6 space-y-4">
          <div className="text-center">
            <h3 className="text-xl font-bold text-slate-900">Aidez-nous à nous faire connaître</h3>
            <p className="text-sm text-slate-600 mt-2 leading-relaxed">
              Pendant votre balade, nous prenons parfois des photos et des vidéos de nos passagers pour partager sur notre TikTok et faire découvrir la lagune du Bénin.
            </p>
          </div>

          <div className="space-y-3 pt-2">
            <button
              data-testid="tiktok-consent-accept"
              disabled={busy}
              onClick={() => pick(true)}
              className="w-full flex items-center gap-3 px-5 py-4 bg-gradient-to-r from-[#F4A340] to-[#E89534] hover:from-[#E89534] hover:to-[#D48222] text-white font-semibold rounded-2xl shadow-md hover:shadow-lg hover:-translate-y-0.5 transition disabled:opacity-60"
            >
              <div className="w-10 h-10 rounded-full bg-white/25 flex items-center justify-center flex-shrink-0">
                <Heart className="w-5 h-5" />
              </div>
              <div className="text-left flex-1">
                <div className="font-bold">Oui, j'accepte</div>
                <div className="text-xs opacity-90">Mes photos peuvent être utilisées sur votre TikTok</div>
              </div>
            </button>

            <button
              data-testid="tiktok-consent-refuse"
              disabled={busy}
              onClick={() => pick(false)}
              className="w-full flex items-center gap-3 px-5 py-4 bg-slate-100 hover:bg-slate-200 text-slate-800 font-semibold rounded-2xl transition disabled:opacity-60"
            >
              <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                <XCircle className="w-5 h-5 text-slate-500" />
              </div>
              <div className="text-left flex-1">
                <div className="font-bold">Non, je refuse</div>
                <div className="text-xs text-slate-500">Je ne souhaite pas apparaître sur TikTok</div>
              </div>
            </button>
          </div>

          <p className="text-[11px] text-slate-400 text-center leading-relaxed pt-2">
            Votre choix n'affecte pas votre réservation. Vous serez ensuite redirigé vers le paiement sécurisé.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TikTokConsentModal;
